/**
 * Appends the active referral campaign code to a URL if one exists in sessionStorage.
 * Used by share buttons to propagate referral attribution through viral shares.
 */
export function appendReferralParam(url: string): string {
  if (typeof window === 'undefined') return url;
  try {
    const campaign = sessionStorage.getItem('ref_campaign');
    if (!campaign) return url;
    const u = new URL(url);
    if (u.searchParams.has('ref')) return url; // already has ref
    u.searchParams.set('ref', campaign);
    return u.toString();
  } catch {
    return url;
  }
}

/**
 * Returns the current page URL with referral param appended if active.
 */
export function getShareUrl(overrideUrl?: string): string {
  const base = overrideUrl || (typeof window !== 'undefined' ? window.location.href : '');
  return appendReferralParam(base);
}
